<div class="container fod" style="margin-top:20px;">
 <!--  <footer>  </footer> -->
    <div class="text-center" style="margin-top:10px;">Uggeløse Vandværk A.m.b.a.<i class="fa fa-circle ho"></i>CVR 3898 1242<i class="fa fa-circle"></i>Uggeløse Bygade 21<i class="fa fa-circle"></i>3540 Lynge<i class="fa fa-circle"></i>e-mail: <a style="font-weight:normal;" href="mailto:vand@uggelosevv.dk">vand&#64;uggelosevv.dk</a></div>
</div>
